<template>
  <div>
    <!-- search box -->
    <section>
      <div class="container">
        <div class="row pt-3">
          <div class="col-12">
            <div class="row bg-white pt-3 custom-shadow">
              <div class="col-12 col-md-5">
                <div class="row">
                  <div class="col-3">
                    <select class="custom-select-sm">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-3">
                    <select class="custom-select-sm p-0">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-3">
                    <select class="custom-select-sm">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn btn-primary btn-sm">查詢</button>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-3">
                    <select class="custom-select-sm">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-6 p-0">
                    <div class="d-flex justify-content-between">
                      <div>
                        <Datepicker />
                      </div>~
                      <div>
                        <Datepicker />
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn btn-primary btn-sm">查詢</button>
                  </div>
                </div>
                <div class="row pt-3">
                  <div class="col-3">
                    <select class="custom-select-sm">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-6 p-0">
                    <div class="form-group">
                      <input type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn btn-primary btn-sm">查詢</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-9 p-0">
                    <div class="d-flex justify-content-between">
                      <div class="custom-control custom-radio custom-control-inline pl-5 ml-4">
                        <input
                          type="radio"
                          id="customRadioInline1"
                          name="customRadioInline1"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="customRadioInline1">所有</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="customRadioInline2"
                          name="customRadioInline1"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="customRadioInline2">新訂單</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="customRadioInline3"
                          name="customRadioInline1"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="customRadioInline3">後續連絡</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          id="customRadioInline4"
                          name="customRadioInline1"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="customRadioInline4">匯款通知</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn btn-primary btn-sm">查詢</button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-1 py-4">
                <div class="w-100 h-100">
                  <hr class="d-block d-md-none m-0 mb-n3" />
                  <div class="px-3 bg-white d-inline-block">且</div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="row">
                  <div class="col-12">
                    <select class="custom-select">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-12 pt-3">
                    <select class="custom-select">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 pt-3">
                    <select class="custom-select">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <div class="col-9 col-md-10 pt-3">
                    <select class="custom-select">
                      <option selected>Choose...</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </div>
                  <a href="#" @click.prevent="showdetailed()" class="col-3 col-md-2 align-self-center pt-3">進階條件</a>
                  <div class="d-flex w-100 h-100 pt-3">
                    <div class="d-flex w-100 h-100" v-if="isShowdetail">
                      <div class="d-flex justify-content-around w-100 h-100">
                        <div>細目狀態：</div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck1" />
                            <label class="custom-control-label" for="customCheck1">全選</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck2" />
                            <label class="custom-control-label" for="customCheck2">(空)</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck3" />
                            <label class="custom-control-label" for="customCheck3">缺貨中</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck4" />
                            <label class="custom-control-label" for="customCheck4">處理中</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck5" />
                            <label class="custom-control-label" for="customCheck5">備貨中</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck6" />
                            <label class="custom-control-label" for="customCheck6">已到貨</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck7" />
                            <label class="custom-control-label" for="customCheck7">已先出貨</label>
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheck8" />
                            <label class="custom-control-label" for="customCheck8">已斷貨</label>
                          </div>
                        </div>
                        <div>
                          <button type="button" class="btn btn-primary btn-sm">查詢</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex">
          <button type="button" class="btn btn-primary" @click="toArrival()">到貨作業</button>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center w-100 h-100 mt-3">
        <label class="m-0" for="sortTable">排序</label>
        <select id="sortTable" class="custom-select-sm ml-3">
          <option selected>Choose...</option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
        <select class="custom-select-sm ml-3 mr-3">
          <option selected>Choose...</option>
          <option value="1">One</option>
          <option value="2">Two</option>
          <option value="3">Three</option>
        </select>
      </div>
      <div class="col-12 pt-3">
        <table class="table">
          <thead>
            <tr>
              <th v-for="(item, index) in fields" :key="index">{{item.name}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in orderList" :key="index">
              <td>{{item.id}}</td>
              <td>{{item.date}}</td>
              <td>{{item.name}}</td>
              <td>{{item.address}}</td>
              <td>{{item.payment}}</td>
              <td><router-link to="/shipManage/shipBase">{{item.ship}}</router-link></td>
              <td>{{item.edit}}</td>
              <td>{{item.other}}</td>
              <td>{{item.total}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  name: "myorder",
  data() {
    return {
      isShowdetail: false
    };
  },
  components: {
    Datepicker
  },
  methods: {
    showdetailed() {
      if (this.isShowdetail) {
        this.isShowdetail = false;
      } else {
        this.isShowdetail = true;
      }
    },
    toArrival() {
      this.$router.push('/arrival');
    },
  },
  computed: {
    fields: {
      get() {
        return this.$store.state.productManage.fields;
      }
    },
    orderList: {
      get() {
        return this.$store.state.productManage.orderList;
      }
    }
  }
};
</script>

<style lang="scss">
.vdp-datepicker {
  input {
    width: 100%;
  }
}
</style>
